import axios from "axios";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  FaBarcode,
  FaCalendarAlt,
  FaEnvelope,
  FaLock,
  FaPhoneAlt,
  FaUser,
} from "react-icons/fa";
import Select from "react-select";
import { Link, Redirect, useLocation, useParams } from "react-router-dom";
import "../../assets/css/scss/component/authentication/_signupFirstForm.scss";
import {
  checkUserAccessAndToken,
  getToken,
  getUserData,
} from "../../common/getLocalStorageData";
import {
  SPONSER_USER_ACCESS,
  STORE_USER_ACCESS,
} from "../../constant/FrontEnd";
import { countryDataArray } from "../../constant/dummyData";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validatePhone } from "../../common/phoneCheck";
import { isMobileOnly } from "react-device-detect";
import { MenuItem, TextField } from "@material-ui/core";
import { FcGoogle } from "react-icons/fc";
import { GoogleOauthContext } from "../../common/context";
import { useGoogleLogin } from "@react-oauth/google";
import { LOGIN_PAGE, SIGN_UP_PAGE } from "../../constant/menuAndProfile";
import { IReduxStateData } from "../../interfaces/redux";
import { useSelector } from "react-redux";

type Iparams = {
  id: string;
};

const errorFieldList = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
  countryCode: "",
  phone: "",
  alphaCode: "",
  brand: "",
  selectedSponsor: "",
  birthDate: "",
  checkbox: "",
  submit: false,
  next: false,
};
export default function SignupForm(props: any) {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  const token = getToken();
  const [birthDate, setBirthDate] = useState(date);
  const [birthDateDummy, setBirthDateDummy] = useState(date);
  const [redirectToScan, setScanPageFlag] = useState(false);
  const [redirectToMyProfile, setMyProfile] = useState(token ? true : false);
  const [alphaCode, setAlphaCode] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [name, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [uuid, setUuid] = useState("");
  const params: Iparams = useParams();
  const [countryData, setCountryData] = useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isActiveNextPage, setActivationNextPage] = useState(false);
  const [errorList, setErrorList] = useState(errorFieldList);
  const [toggleFlag, setToggleFlag] = useState(false);
  const [isCheckboxCheck, setCheckboxCheck] = useState(false);
  const [brandStoreAddress, setBrandStoreAddress] = useState([]);
  const [selectedBrandStoreAddress, setSelectedBrandStoreAddress] =
    useState("");
  const [selectedSponsorUuid, setSelectedSponsorUuid] = useState("");
  const [loginMessage, setLoginMessage] = useState({
    message: "",
    type: "",
  });
  const [redirectToPage, setRedirectToPage] = useState("");
  const [redirectToLoginWithMessage, setRedirectToLoginWithMessage] =
    useState("");
  const [isNextButtonOneTimeClick, setNextButtonOneTimeClick] = useState(false);
  // const storeAccess = ;
  const location = useLocation();
  const sponsorSignup = location?.pathname.split("/")[1] === "sponsor";
  const storeSignup = location?.pathname.split("/")[1] === "store";
  const userSignup = location?.pathname.split("/")[1] === "register";
  const [brandList, setBrandList] = useState<any>([]);
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";

  const [user, setUser] = useState<any>({});
  const [profile, setProfile] = useState({});
  const isGoogleOauthEnable = useContext(GoogleOauthContext);

  useEffect(() => {
    if (props?.isBackButtonDisplay) {
      setActivationNextPage(true);
    } else {
      setActivationNextPage(false);
    }
  }, [props?.isBackButtonDisplay]);

  useEffect(() => {
    if (sponsorSignup) {
      (async function () {
        await axios
          .get(process.env.REACT_APP_API_URL + "/sponsor/getBrandName")
          .then(function (response) {
            // handle success
            if (response.data && response.data.success) {
              let brandArray: any = [];
              response.data.success.map((data: any, index: number) => {
                if (data.brand_name) {
                  brandArray.push(data.brand_name.trim().toLowerCase());
                }
              });
              setBrandList(brandArray);
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
      })();
    }
  }, [sponsorSignup]);

  useEffect(() => {
    if (storeSignup) {
      (async function () {
        await axios
          .get(
            process.env.REACT_APP_API_URL + "/store/getRegistrationStoreData"
          )
          .then(function (response) {
            // handle success
            if (response.data?.success && response.data.success.length) {
              setBrandStoreAddress(response.data.success);
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
      })();
    }
  }, [storeSignup]);
  useEffect(() => {
    const isAlreayLoginGetUserId = getUserData();
    if (isAlreayLoginGetUserId) {
      alert("Your are alreay login..");
      setMyProfile(true);
    } else {
      const fetchData = async () => {
        if (!selectedCountry) {
          let iso_code: string;
          await axios
            .get(process.env.REACT_APP_API_URL + "/common/find-trace")
            .then(function (response) {
              // handle success
              if (response.data?.success) {
                if (
                  response.data.success?.[
                    process.env.REACT_APP_COUNTRY_PARAMETER ?? ""
                  ]
                ) {
                  iso_code =
                    response.data.success[
                      process.env.REACT_APP_COUNTRY_PARAMETER ?? ""
                    ].trim();
                  setToggleFlag(!toggleFlag);
                }

                // Optional: You can also access other trace data
                // const userIP = response.data.data.ip;
                // const dataCenter = response.data.data.colo;
                // const timestamp = response.data.data.timestamp;
              }
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            });
          await axios
            .get(process.env.REACT_APP_API_URL + "/common/get-country-list")
            .then(function (response) {
              if (response.data && response.data.success) {
                let country_index = "";
                response.data.success.filter(function (data: any, index: any) {
                  if (data.iso_code.toString() === iso_code) {
                    country_index = index;
                    return;
                  }
                });
                console.log("kjjjj >", response.data.success);
                setCountryData(response.data.success);
                setSelectedCountry(country_index);
                setToggleFlag(!toggleFlag);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          let country_index = "";
          countryDataArray?.filter(function (data: any, index: any) {
            if (data.iso_code.toString() === iso_code) {
              country_index = index;
              return;
            }
          });
          setCountryData(countryDataArray);
          setSelectedCountry(country_index);
        }
      };
      fetchData();
    }
  }, []);

  const onChangeBrandName = (value: any) => {
    if (value.length >= 1) {
      // if (validationMsgs['isSubmited']) {
      //     validationMsgs['brandName'] = "";
      // }
      let errorData = { ...errorList };
      if (brandList.includes(value.trim().toLowerCase())) {
        errorData["brand"] = "Please Select different Brand Name";
      } else {
        errorData["brand"] = "";
      }
      setErrorList(errorData);
    }
    setSelectedBrand(value);
  };

  // const getOptions = () => {
  //   let countryDropDownData: any[] = [];
  //   countryData.map((data, index) => {
  //     const optionValue =
  //       data["country_code"].padEnd(5) + " " + data["country_name"];
  //     countryDropDownData.push(
  //       <option
  //         selected={parseInt(selectedCountry) === index ? true : false}
  //         value={index}
  //         label={data["country_code"].slice(1, 5)}
  //       >
  //         {optionValue}
  //       </option>
  //     );
  //   });
  //   return countryDropDownData;
  // };

  const getOptions = () => {
    return countryData.map((data, index) => ({
      value: index,
      label: data["country_code"].padEnd(5) + " " + data["country_name"],
      countryCode: data["country_code"].slice(1, 5),
    }));
  };

  useEffect(() => {
    if (params && params.id) {
      setIdentifier(params["id"]);
    }
  }, [params.id]);

  console.log("location >", useLocation()?.pathname.split("/")[1]);

  useEffect(() => {
    if (identifier) {
      axios
        .get(
          process.env.REACT_APP_API_URL + "/deal/get-alphacode/" + identifier
        )
        .then(function (response) {
          if (response.data.success && response.data.success.alphacode) {
            setAlphaCode(response.data.success.alphacode);
            setToggleFlag(!toggleFlag);
          }
          if (response.data.success && response.data.success.uuid) {
            setUuid(response.data.success.uuid);
          }
        })
        .catch(function (error) {
          console.log(error);
          if (error?.response?.data?.message) {
            setLoginMessage({
              message: error.response.data.message,
              type: "error",
            });
            setTimeout(() => {
              setLoginMessage({ message: "", type: "" });
            }, 10000);
          }
        });
    }
  }, [identifier]);

  const checkValidationSubmit = (
    e: any,
    isNextClick: boolean = false,
    isSubmit: boolean = true
  ) => {
    const errorData = { ...errorFieldList };
    let isValidateForm = true;
    if (!name) {
      isValidateForm = false;
      errorData["name"] = "Please enter full name";
    }
    if (!email) {
      isValidateForm = false;
      errorData["email"] = "Please enter valid email address";
    }
    console.log(
      "asdasd >",
      countryData[parseInt(selectedCountry)],
      countryData[parseInt(selectedCountry)]["country_code"],
      phone
    );
    if (
      !phone ||
      !validatePhone(
        countryData[parseInt(selectedCountry)]["country_code"] + phone
      )
    ) {
      isValidateForm = false;
      errorData["phone"] = "Please enter valid phone";
    }
    if (!birthDate && birthDate !== birthDateDummy) {
      isValidateForm = false;
      errorData["birthDate"] = "Please enter valid birth Date";
    }
    if (userSignup && !alphaCode) {
      isValidateForm = false;
      errorData["alphaCode"] = "Please click on code and scan QR code";
    }
    if (sponsorSignup && !selectedBrand) {
      isValidateForm = false;
      errorData["brand"] = "Please select brand";
    }
    if (storeSignup && !selectedBrandStoreAddress) {
      isValidateForm = false;
      errorData["selectedSponsor"] = "Please select sponsor";
    }
    if (!isNextClick) {
      errorData["submit"] = true;
      errorData["next"] = false;
      if (!password) {
        isValidateForm = false;
        errorData["password"] = "Please enter valid password";
      }
      if (!confirmPassword || (password && password !== confirmPassword)) {
        isValidateForm = false;
        errorData["confirmPassword"] = "Please enter valid confirm password";
      }
      if (!isCheckboxCheck) {
        isValidateForm = false;
        errorData["checkbox"] = "Please select terms and policy";
      }
      if (isValidateForm && isSubmit) {
        submitRegisterData(e);
      }
    } else {
      errorData["next"] = true;
      errorData["submit"] = false;
      // if (isValidateForm && isSubmit) {
      props?.backButtonClick(true);
      setNextButtonOneTimeClick(true);
      setActivationNextPage(true);
      // }
    }
    setErrorList(errorData);
    setToggleFlag(!toggleFlag);
  };

  const submitRegisterData = async (e: any) => {
    console.log("submitRegisterData >>");
    e.preventDefault();
    let data = {
      name: name,
      password: password,
      email: email,
      phone: phone,
      birthday: birthDate.toISOString().replace("T", " ").replace("Z", " "),
      country_code: countryData[parseInt(selectedCountry)]["id"],
    };
    let apiUrl = "/auth/registration";
    if (userSignup) {
      data["uuid"] = uuid;
      data["alphacode"] = alphaCode;
    } else if (sponsorSignup) {
      apiUrl = "/sponsor/registration";
      data["brand_name"] = selectedBrand;
    } else if (storeSignup) {
      apiUrl = "/store/registration";
      data["address_id"] = parseInt(selectedBrandStoreAddress);
      data["sponsor_uuid"] = selectedSponsorUuid;
    }
    await axios
      .post(process.env.REACT_APP_API_URL + apiUrl, data)
      .then(function (response) {
        console.log(response.data, response.data.success);
        setTimeout(() => {
          // setRedirectToLoginWithMessage(
          //   "Almost there! We have sent you an email. Please click on the confirmation link to complete your registration."
          // );
          setRedirectToLoginWithMessage(
            "Congratulations! You have successfully registered. Please login to continue."
          );
        }, 10);
        if (
          response.data.success &&
          response.data.success.token &&
          response.data.success.user
        ) {
          console.log("test test", response.data.success);
        }
      })
      .catch(function (error) {
        console.log(error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          props?.backButtonClick(false);
          setActivationNextPage(false);
          setLoginMessage({
            message: error.response.data.message,
            type: "error",
          });
          setTimeout(() => {
            setLoginMessage({ message: "", type: "" });
          }, 10000);
        }
        // setLoading(false);
      });
  };

  const login = useGoogleLogin({
    scope:
      "https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/user.birthday.read",
    onSuccess: (codeResponse: any) => {
      console.log("codeResponse >", codeResponse);
      setUser(codeResponse);
    },
    onError: (error) => {
      console.log("Login Failed:", error);
    },
  });
  useEffect(() => {
    if (user?.access_token) {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?alt=json`, {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: "application/json",
          },
        })
        .then((res: any) => {
          console.log("ff >", res);
          setProfile(res.data);
          axios
            .get(
              `https://people.googleapis.com/v1/people/${res.data.id}?personFields=phoneNumbers,genders,birthdays`,
              {
                headers: {
                  Authorization: `Bearer ${user.access_token}`,
                  Accept: "application/json",
                },
              }
            )
            .then((final) => {
              console.log("final >", final.data);
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  const onChangeForm = (e: any, isNextClick: boolean = false) => {
    // if (errorList?.next || errorList?.submit)
    //   checkValidationSubmit(e, isNextClick, false);
  };
  const isCheckField = isMobileOnly
    ? errorList.submit
    : isNextButtonOneTimeClick || errorList.next;
  return (
    <div className="login-form-div" key={toggleFlag ? "true" : "false"}>
      {redirectToScan ? <Redirect to="/scan" /> : null}
      {redirectToMyProfile ? <Redirect to="/user/profile" /> : null}
      {redirectToPage ? <Redirect to={redirectToPage} /> : null}

      {redirectToLoginWithMessage ? (
        <Redirect
          to={{
            pathname: "/login",
            state: { message: redirectToLoginWithMessage },
          }}
        />
      ) : null}
      {loginMessage.message ? (
        <div
          className={
            loginMessage.type === "success"
              ? "form-response success"
              : "form-response error"
          }
        >
          {loginMessage.message}
        </div>
      ) : null}
      <Form key={toggleFlag ? 0 : 1}>
        {/* First part form */}
        {!isActiveNextPage ? (
          <Fragment>
            <Form.Group
              className={`form-group ${name ? "focus" : ""} ${
                isCheckField
                  ? errorList.name
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formName"
            >
              <Form.Label>{SIGN_UP_PAGE[selectedLang]["name"]}</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => {
                  setUserName(e.target.value);
                  onChangeForm(e, true);
                }}
                className={`${
                  isCheckField
                    ? errorList.name
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaUser />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group ${email ? "focus" : ""} ${
                isCheckField
                  ? errorList.email
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formBasicEmail"
            >
              <Form.Label>{SIGN_UP_PAGE[selectedLang]["email"]}</Form.Label>
              <Form.Control
                type="email"
                autoComplete="new-email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  onChangeForm(e, true);
                }}
                className={`${
                  isCheckField
                    ? errorList.email
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaEnvelope />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group focus ${
                isCheckField
                  ? errorList.phone
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formNumber"
            >
              <Form.Label>{SIGN_UP_PAGE[selectedLang]["phoneNo"]}</Form.Label>
              {countryData.length ? (
                <Select
                  options={getOptions()}
                  value={getOptions().find(
                    (option) => option.value === parseInt(selectedCountry)
                  )}
                  onChange={(selectedOption) => {
                    setSelectedCountry(selectedOption.value);
                    onChangeForm(null, true);
                  }}
                  isSearchable
                  maxMenuHeight={500}
                  placeholder="Select Country"
                  className="country-select"
                  classNamePrefix="react-select"
                />
              ) : // <Form.Select
              //   id="formNumberOption"
              //   className="form-select form-select-sm custom-select"
              //   aria-label="Default select example"
              //   onChange={(e) => {
              //     setSelectedCountry(e.target.value);
              //     onChangeForm(e, true);
              //   }}
              //   size="sm"
              // >
              //   {getOptions()}
              // </Form.Select>
              null}
              <Form.Control
                type="number"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  onChangeForm(e, true);
                }}
                className={`custom-phone-input ${
                  isCheckField
                    ? errorList.phone
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaPhoneAlt />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group ${birthDateDummy ? "focus" : ""} ${
                isCheckField
                  ? errorList.birthDate
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formBirthday"
            >
              <Form.Label>{SIGN_UP_PAGE[selectedLang]["birthday"]}</Form.Label>
              <DatePicker
                dateFormat={"dd/MM/yyyy"}
                maxDate={date}
                selected={birthDate}
                onChange={(date: any) => {
                  setBirthDate(date);
                }}
                customInput={
                  <Form.Control
                    type="text"
                    onChange={(date: any) => setBirthDateDummy(date)}
                    className={`${
                      isCheckField
                        ? errorList.birthDate
                          ? "focus-error"
                          : "focus-success"
                        : ""
                    }`}
                  />
                }
              />
              <span className="input-append">
                <FaCalendarAlt />
              </span>
            </Form.Group>
            {userSignup ? (
              <Form.Group
                className={`form-group ${alphaCode ? "focus" : ""} ${
                  isCheckField
                    ? errorList.alphaCode
                      ? "field-group-error"
                      : "field-group-success"
                    : ""
                }`}
                controlId="formCode"
              >
                <Form.Label>
                  {SIGN_UP_PAGE[selectedLang]["alphaCode"]}
                </Form.Label>
                <Form.Control
                  readOnly={true}
                  // onClick={(e) => setScanPageFlag(true)}
                  type="text"
                  onChange={(e) => {
                    onChangeForm(e, true);
                  }}
                  value={alphaCode}
                  className={`${
                    isCheckField
                      ? errorList.alphaCode
                        ? "focus-error"
                        : "focus-success"
                      : ""
                  }`}
                />
                <span className="input-append">
                  <FaBarcode />
                </span>
              </Form.Group>
            ) : null}
            {sponsorSignup ? (
              // <Form.Group className={`form-group `} controlId="formBrand">
              //   <TextField
              //     label="Brand"
              //     select
              //     className={`mui-dropdown ${isCheckField ? errorList.brand ? "field-error" : "field-success" : ""}`}
              //     fullWidth
              //     variant="outlined"
              //     value={selectedBrand}
              //     id="pac-brand"
              //     margin="dense"
              //     onChange={(e) => {
              //       setSelectedBrand(e.target.value)
              //     }}
              //   >
              //     <MenuItem value="" selected={true}>Please select brand</MenuItem>
              //     {brandList?.map((brand_name: any, index) => (
              //       <MenuItem key={brand_name + "-" + index}
              //         selected={brand_name === selectedBrand}
              //         value={brand_name}>
              //         {brand_name}
              //       </MenuItem>
              //     ))}
              //   </TextField>
              // </Form.Group>
              <Form.Group
                className={`form-group ${selectedBrand ? "focus" : ""} ${
                  errorList.brand
                    ? "field-group-error"
                    : isCheckField
                    ? "field-group-success"
                    : ""
                }`}
                controlId="formName"
              >
                <Form.Label>{SIGN_UP_PAGE[selectedLang]["brand"]}</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedBrand}
                  onChange={(e) => {
                    onChangeBrandName(e.target.value);
                    onChangeForm(e, true);
                  }}
                  className={`${
                    errorList.brand
                      ? "focus-error"
                      : isCheckField
                      ? "focus-success"
                      : ""
                  }`}
                />
                <span className="input-append">
                  <FaUser />
                </span>
              </Form.Group>
            ) : null}
            {storeSignup ? (
              <Form.Group className={`form-group `} controlId="formSponsor">
                <TextField
                  label="Sponsor"
                  select
                  className={`mui-dropdown ${
                    isCheckField
                      ? errorList.selectedSponsor
                        ? "field-error"
                        : "field-success"
                      : ""
                  }`}
                  fullWidth
                  variant="outlined"
                  value={selectedBrandStoreAddress + "/" + selectedSponsorUuid}
                  id="pac-brand"
                  margin="dense"
                  onChange={(e) => {
                    const addressSponsor = e.target.value.split("/");
                    setSelectedBrandStoreAddress(addressSponsor[0]);
                    setSelectedSponsorUuid(addressSponsor[1]);
                  }}
                >
                  <MenuItem value="" selected={true}>
                    {SIGN_UP_PAGE[selectedLang]["selectSponsor"]}
                  </MenuItem>
                  {brandStoreAddress?.map((data: any, index) => (
                    <MenuItem
                      key={data.address_id + "-" + index}
                      selected={
                        data.address_id + "/" + data.sponsor_uuid ===
                        selectedBrandStoreAddress + "/" + selectedSponsorUuid
                      }
                      value={data.address_id + "/" + data.sponsor_uuid}
                    >
                      {data["store_name"] + " - " + data["address1"]}
                    </MenuItem>
                  ))}
                </TextField>
              </Form.Group>
            ) : null}
            <Form.Group
              className={`form-group d-block d-md-none ${
                password ? "focus" : ""
              } ${
                isCheckField
                  ? errorList.password
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formPassword"
            >
              <Form.Label>{SIGN_UP_PAGE[selectedLang]["password"]}</Form.Label>
              <Form.Control
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`${
                  isCheckField
                    ? errorList.password
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaLock />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group d-block d-md-none ${
                confirmPassword ? "focus" : ""
              }  ${
                isCheckField
                  ? errorList.confirmPassword
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formCPassword"
            >
              <Form.Label htmlFor="confirmPassword">
                {SIGN_UP_PAGE[selectedLang]["confirmPassword"]}
              </Form.Label>
              <Form.Control
                type="password"
                autoComplete="new-password"
                value={confirmPassword}
                id="confirmPassword"
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={`${
                  isCheckField
                    ? errorList.confirmPassword
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaLock />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group d-block d-md-none ${
                errorList.submit
                  ? errorList.checkbox
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formBasicCheckbox"
            >
              <Form.Check
                type="checkbox"
                label="I agree all terms & conditions"
                checked={isCheckboxCheck}
                onClick={() => setCheckboxCheck(!isCheckboxCheck)}
                className={`${
                  errorList.submit
                    ? errorList.checkbox
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              className="font-semibold d-block d-md-none"
              onClick={(e) => {
                checkValidationSubmit(e, false);
              }}
            >
              {SIGN_UP_PAGE[selectedLang]["button"]}
            </Button>
            <Button
              type="button"
              className="font-semibold btn btn-next d-none d-md-block"
              onClick={(e) => {
                checkValidationSubmit(e, true);
              }}
            >
              {SIGN_UP_PAGE[selectedLang]["next"]}
            </Button>
          </Fragment>
        ) : (
          <Fragment>
            <Form.Group
              className={`form-group ${password ? "focus" : ""} ${
                errorList.submit
                  ? errorList.password
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formPassword"
            >
              <Form.Label>{SIGN_UP_PAGE[selectedLang]["password"]}</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`${
                  errorList.submit
                    ? errorList.password
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaLock />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group ${confirmPassword ? "focus" : ""} ${
                errorList.submit
                  ? errorList.confirmPassword
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="confirmPassword"
            >
              <Form.Label htmlFor="confirmPassword">
                {SIGN_UP_PAGE[selectedLang]["confirmPassword"]}
              </Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                id="confirmPassword"
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={`${
                  errorList.submit
                    ? errorList.confirmPassword
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
              <span className="input-append">
                <FaLock />
              </span>
            </Form.Group>
            <Form.Group
              className={`form-group ${
                errorList.submit
                  ? errorList.checkbox
                    ? "field-group-error"
                    : "field-group-success"
                  : ""
              }`}
              controlId="formBasicCheckbox"
            >
              <Form.Check
                type="checkbox"
                label={SIGN_UP_PAGE[selectedLang]["condition"]}
                checked={isCheckboxCheck}
                onClick={() => setCheckboxCheck(!isCheckboxCheck)}
                className={`${
                  errorList.submit
                    ? errorList.checkbox
                      ? "focus-error"
                      : "focus-success"
                    : ""
                }`}
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              className="font-semibold"
              onClick={(e) => {
                checkValidationSubmit(e, false);
              }}
            >
              {SIGN_UP_PAGE[selectedLang]["button"]}
            </Button>
          </Fragment>
        )}
      </Form>
      <p className="sign-up-link">
        {SIGN_UP_PAGE[selectedLang]["accountMessage"]}{" "}
        <Link to="/login">{LOGIN_PAGE[selectedLang]["title"]}</Link>
      </p>
      {isGoogleOauthEnable ? (
        <div className="bottom-card d-md-none text-center">
          <p className="theme-green">Or</p>
          <button
            className="btn btn-fb d-flex align-items-center justify-content-center"
            onClick={() => login()}
          >
            <span>
              {SIGN_UP_PAGE[selectedLang]["signUpWithGoogle"]} <FcGoogle />
            </span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
